module.exports = __webpack_public_path__ + "media/images/home/4-78176df55f249b2cf2fcac20995d8915.png";